<template>
  <table id="draggabletable" class="table table-striped table-bordered">
    <thead>
      <tr>
        <th v-for="(item, key, index) in columnTitles" :key="index">
          {{ item }}
        </th>
      </tr>
    </thead>
    <draggable
      v-model="tableRow"
      :element="'tbody'"
      :options="{ handle: '.handle' }"
      @end="onEnd"
    >
      <tr v-for="(item, key, index) in tableRow" :key="index">
        <td class="handle">
          {{ item.itemCode }}
        </td>
        <td>
          {{ item.name }}
        </td>
        <td>
          <input
            :checked="!item.unVisibleFlag"
            @change="changeUnVisibleFlag(item)"
            type="checkbox"
          />
        </td>
        <td>
          <input
            :checked="item.wideView"
            @change="changeWideView(item)"
            type="checkbox"
          />
        </td>
        <td>
          <button
            @click="deleteItem(item.itemCode)"
            class="btn btn-danger btn-xs"
          >
            {{ $t('common.delete') }}
          </button>
        </td>
      </tr>
    </draggable>
  </table>
</template>
<script>
import draggable from 'vuedraggable'
// store
import { mapGetters } from 'vuex'

export default {
  components: {
    draggable,
  },
  props: ['columnTitles'],
  data() {
    return {
      currentToggle: 0,
      tableRow: [],
    }
  },
  computed: {
    ...mapGetters({
      menuItemsByCategoryCode: 'menu/getMenuItemsByCategoryCode',
      currentCategoryCode: 'menu/getCurrentCategoryCode',
    }),
  },
  watch: {
    currentCategoryCode: function(categoryCode) {
      this.tableRow = this.menuItemsByCategoryCode(categoryCode)
    },
  },
  mounted() {
    this.tableRow = this.menuItemsByCategoryCode(this.currentCategoryCode)
  },
  methods: {
    // 商品削除
    deleteItem: function(itemCode) {
      this.$store.dispatch('menu/deleteItem', itemCode)
    },
    // メニュー表示フラグの更新
    changeUnVisibleFlag: function(item) {
      item.unVisibleFlag = item.unVisibleFlag === 1 ? 0 : 1
      this.$store.dispatch('menu/updateMenuItem', item)
    },
    // ワイド表示フラグの更新
    changeWideView: function(item) {
      item.wideView = item.wideView === 1 ? 0 : 1
      this.$store.dispatch('menu/updateMenuItem', item)
    },
    // 並び替え後の処理
    onEnd: function() {
      this.$store.dispatch('menu/sortMenuItem', this.tableRow)
    },
  },
}
</script>
<style scoped>
thead th {
  position: relative;
}
thead th::after {
  content: '';
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: block;
  width: 10px;
  height: 10px;
  opacity: 0.5;
}
.handle {
  cursor: move;
}
</style>
